import request, { downloadFile } from "../utils/request";

/**
 * 创建学员信息
 * @param {*} data
 * @returns
 */
export async function createStudentInfo(data) {
  const res = await request({
    url: "/user_base_info/insert",
    data,
    method: "post",
  });

  return res;
}

export async function getStudentInfoList(data) {
  const res = await request({
    url: "/user_base_info/list",
    data,
    method: "post",
  });

  return res;
}

export async function updateStudentInfo(data) {
  const res = await request({
    url: "/user_base_info/update",
    data,
    method: "post",
  });

  return res;
}

export async function postStudentInfoByExcel(params) {
  const res = await request({
    url: "/user_base_info/upload",
    method: "get",
    params,
  });

  return res;
}
